export default {
	root: {},
	child: {
		backgroundColor: 'black'
	}
};
